/**
 * @generated SignedSource<<12d07ced7e5b4af2684228d53429a35b>>
 * @relayHash 54a305f918a787589a77e8d5c898026b
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 444e6048d20cdfb98399a3b985e5a9a989d8407910b31465971b237984ad5f35

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { uiVersionDetailsQuery } from './uiVersionDetailsQuery.graphql';

const node: PreloadableConcreteRequest<uiVersionDetailsQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "444e6048d20cdfb98399a3b985e5a9a989d8407910b31465971b237984ad5f35",
    "metadata": {},
    "name": "uiVersionDetailsQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
